import React from "react";
import PropTypes from "prop-types";
import { PageSection } from "components/page";
import { AutocompleteConnected } from "components/autocomplete";
import { injectIntl } from "react-intl";
import { usersQuery } from "../table";
import { useAuthDataContext } from "components/auth";
import { useCurrentCustomerContext } from "../../../components/current-customer-context";

const SearchForm = ({ onChange, intl }) => {
  const { hasAdminPrivileges, manageableUserRoles } = useAuthDataContext();
  const { contractIds } = useCurrentCustomerContext();
  return (
    <PageSection spaced>
      <AutocompleteConnected
        variables={{ contractIds, roles: hasAdminPrivileges ? null : manageableUserRoles }}
        onChange={onChange}
        gqlQuery={usersQuery}
        getElementsFromDataHandler={data => data.users}
        getSuggestionValue={item => item.username}
        placeholder={intl.formatMessage({ id: "app.page.user.list.search" })}
        label={intl.formatMessage({ id: "app.page.user.list.search.label" })}
      />
    </PageSection>
  );
};

SearchForm.propTypes = {
  /**
   * Callback que se invoca cuando cambia el texto de búsqueda
   */
  onChange: PropTypes.func,
};

export default injectIntl(SearchForm);
